// extracted by mini-css-extract-plugin
export default {"base":"ColumnChartDisplay_base__ecgVw","select":"ColumnChartDisplay_select__aLKkr"};